module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.4-edit-card.978b33c3.png";